exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-footer{position:relative}.modal-footer .loader-wrapper{margin-left:50px}.modal-footer .loader-wrapper .loader-container{position:absolute!important}", ""]);

// exports
